<template>
  <div class="card-body">
    <slot></slot>
  </div>
</template>

<script>
export default {};
</script>

<style lang='scss' scoped>
@import '@/assets/scss/_variables.scss';

.card-body {
  position: relative;
  padding: 0.5rem;
  border: 0.1px solid rgb(219, 219, 219);

  .name {
    color: #2798d2;
    font-family: $font-family-sans-lato;
    font-size: 14px;
  }

  /* .details {
    font-family: $font-family-sans-lato;
    font-size: 12px;
    white-space: nowrap;
  } */

  .jobshark-marker {
    position: absolute;
    height: 60px;
    right: 3px;
    top: 3px;
    border-left: 5px solid $color-jobshark-marker;
    border-radius: 5px;
  }

  .rounded-circle {
    width: 42px;
    height: auto;
    margin-right: 13px;
  }
}

// Media queries
@media screen and (max-width: 1600px) {
  .card-body {
    .name {
      font-size: 14px;
    }
  }
}
</style>